module.exports = __webpack_public_path__ + "static/media/48425271_2308816195860225_8242846241721942016_o-thumb.8813fbeb.jpg";